import { AGENT_URL } from '@/config/env'
import { fetchJsonWithAuth, mutateJsonWithAuth } from '@/lib/api'
import type {
  BillingCreditChange,
  BillingCreditRequest,
  BillingCreditsResponse,
  CurrentUsageResponse,
  DutyCallCostsResponse,
  MonthEndUsageResponse,
  RateCardChange,
  RateCardChangeRequest,
} from '../types'

export function fetchCurrentUsage(
  token: string,
  signal?: AbortSignal
): Promise<CurrentUsageResponse> {
  return fetchJsonWithAuth<CurrentUsageResponse>({
    token,
    url: `${AGENT_URL}/billing/usage/current`,
    signal,
    errorMessage: 'Failed to fetch current billing usage',
  })
}

export function fetchMonthEndUsage(
  token: string,
  period: string,
  signal?: AbortSignal
): Promise<MonthEndUsageResponse> {
  const search = new URLSearchParams({ period })
  return fetchJsonWithAuth<MonthEndUsageResponse>({
    token,
    url: `${AGENT_URL}/billing/usage/month-end?${search.toString()}`,
    signal,
    errorMessage: 'Failed to fetch month-end billing usage',
  })
}

export function fetchDutyCallCosts(
  token: string,
  period: string,
  signal?: AbortSignal
): Promise<DutyCallCostsResponse> {
  const search = new URLSearchParams({ period })
  return fetchJsonWithAuth<DutyCallCostsResponse>({
    token,
    url: `${AGENT_URL}/billing/usage/duties?${search.toString()}`,
    signal,
    errorMessage: 'Failed to fetch per-duty billing costs',
  })
}

export function fetchBillingCredits(
  token: string,
  period: string,
  signal?: AbortSignal
): Promise<BillingCreditsResponse> {
  const search = new URLSearchParams({ period })
  return fetchJsonWithAuth<BillingCreditsResponse>({
    token,
    url: `${AGENT_URL}/billing/usage/credits?${search.toString()}`,
    signal,
    errorMessage: 'Failed to fetch billing credits',
  })
}

export function addBillingCredit(
  token: string,
  body: BillingCreditRequest
): Promise<BillingCreditChange> {
  return mutateJsonWithAuth<BillingCreditChange>({
    token,
    url: `${AGENT_URL}/billing/credits`,
    method: 'POST',
    body,
    errorMessage: 'Failed to add billing credit',
  })
}

export function updateBillingRateCard(
  token: string,
  body: RateCardChangeRequest
): Promise<RateCardChange> {
  return mutateJsonWithAuth<RateCardChange>({
    token,
    url: `${AGENT_URL}/billing/rate-card`,
    method: 'POST',
    body,
    errorMessage: 'Failed to change rate card',
  })
}
